import type { AppState } from "../@types/context";
import { storageKey } from "./constants";

const existingStore = window.sessionStorage.getItem(storageKey);
export const cachedStore: AppState | null = existingStore
  ? JSON.parse(existingStore)
  : null;
export { storageKey } from "./constants";
